import type { AnyObject } from 'syf-js-utilities/typings/AnyObject'
import { FieldError } from 'typings/FieldErrors'

/**
 * Gets the first FieldError in the provided response.
 * @param responseData - the parsed response data (json) coming from a fetch function or a raw response
 * @returns (obj) FieldError or FieldError with empty values if no match found
 */
const getFirstFieldErrorInResponse = (responseData: AnyObject): FieldError => {
  const hasErrorsArray = !!responseData?.errors

  if (!responseData || !hasErrorsArray) {
    return { field: '', reason: '' }
  }

  return responseData.errors[0]
}

export default getFirstFieldErrorInResponse
